var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-forward-dropdown"},_vm._l((_vm.groups),function(dialog,i){return _c('MiniMember',{key:i,attrs:{"dialog":dialog},nativeOn:{"click":function($event){return _vm.$emit('select', dialog)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }